import React, {Component} from 'react';
import Picker from '../widgets/Picker';
import fetchJson from '../fetchJson';
import createPauser from '../pauser';
import {connect} from 'react-redux';
import uiActions from '../chrome/ui.actions';
import handleError from '../handleError';

const SEARCH_LIMIT = 100;

const ENCODE_SPACES = / /g; // Encode spaces as underscores due to double encoding
const categoryToSearch = category =>
	category ? `category:${category.replace(ENCODE_SPACES, '_')} ` : '';

/**
 * Community popup picker
 */
export class CommunityPicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			items: [],
			searchValue: ''
		};

		this.performSearch = createPauser(async () => {
			try {
				const {searchValue} = this.state;
				if (searchValue) {
					this.setState({
						loading: true
					});
					const fetcher = this.props.fetcher || fetchJson;
					const items = (await fetcher(
						`/api/search/${encodeURIComponent(
							categoryToSearch(this.props.pickerPrefill) + searchValue
						)}?type=community&limit=${SEARCH_LIMIT}`
					)).map(item => ({
						value: item.uuid,
						label: item.name,
						extra: item.location && item.location.suburb,
						data: item
					}));
					this.setState({
						loading: false
					});
					this.setState({items});
				} else {
					this.setState({items: []});
				}
			} catch (e) {
				this.props.onError();
				this.props.cancel();
			}
		}, 500);
		this.onSearchChange = e => {
			this.setState({searchValue: e.target.value});
			this.performSearch();
		};
	}

	render() {
		return (
			<Picker
				loading={this.state.loading}
				title="Choose a community"
				searchPlaceholder="Refine search by name, postcode, suburb etc"
				selectionMapper={item => item && item.data}
				onChangeSearch={this.onSearchChange}
				items={this.state.items}
				preamble={
					this.props.pickerPrefill ? (
						<p>
							Browsing communities in the <i>{this.props.pickerPrefill}</i> category:
						</p>
					) : (
						undefined
					)
				}
				searchValue={this.state.searchValue}
			/>
		);
	}
}

const ConnectedCommunityPicker = connect(
	state => ({
		pickerPrefill: state.ui.pickerPrefill
	}),
	dispatch => ({
		cancel: () => dispatch(uiActions.uiModal(null)),
		onError: handleError(dispatch)
	})
)(CommunityPicker);

export default ConnectedCommunityPicker;



// WEBPACK FOOTER //
// ./src/search/CommunityPicker.js